module.exports = __webpack_public_path__ + "img/login-default.ec767760.png";